<template>

<app-view-list-field align="center" :is-sticky="isSticky" :field="field" :filter="filter">

    <core-date :date="value" invalid="n/a" />

</app-view-list-field>

</template>

<script>

export default {

	props: ['field', 'filter', 'item', 'isSticky'],

	computed: {

		value: function() {

			return (this.item.collection) ? this.item.collection.dates.updated : false

		}

	}

}

</script>

<style scoped>

</style>